module.exports = __webpack_public_path__ + "assets/img/footer-blob-bottom.d38304a1.webp";